import { LDClient } from "launchdarkly-js-client-sdk"
import { UUID } from "io-ts-types/lib/UUID"

// --------------------------------------------------------------------------------------------------------------------

type ClientDetailsCustom = Readonly<{
  userType?: "broker" | "customer" | "flocker" | "claims_admin" | "carrier"
  policyNumber?: string
  policyId?: UUID
  supportsEfnol?: boolean
}>

type ClientDetails = Readonly<{
  key: string
  email: string
  name: string
  custom: ClientDetailsCustom
}>

export type AppViewer = Readonly<{
  key: string
  email: string
  name: string
  userType: `broker` | `customer` | `flocker` | `claims_admin` | `carrier`
}>

// --------------------------------------------------------------------------------------------------------------------

export const identifyLDUser = (
  client: LDClient,
  viewer: AppViewer,
  policy?: Readonly<{ policyNumber: string; id: UUID; fnolClaimsAdmin?: { supportsEfnol: boolean } | null }>
): void => {
  const clientDetails: ClientDetails = {
    key: viewer.key,
    email: viewer.email,
    name: viewer.name,
    custom: policy
      ? {
          policyId: policy.id,
          policyNumber: policy.policyNumber,
          supportsEfnol: policy.fnolClaimsAdmin?.supportsEfnol ?? false,
          userType: viewer.userType,
        }
      : {},
  }

  client.identify(clientDetails)
}
